import React, { useMemo, useState } from 'react';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import styles from 'assets/jss/material-dashboard-pro-react/components/jawazakTableStyle';
import { makeStyles } from '@material-ui/core';
import { translate } from 'components/Translation';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import SingleJawazakTable from './subcomponents/SingleJawazakTable';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IJawazakTableProps {
	catalogEntryView: types.ecommerce.CatalogEntryView[];
	setSelectedCatalogEntryView: React.Dispatch<React.SetStateAction<types.ecommerce.CatalogEntryView | null>>;
}

const JawazakTable = ({ catalogEntryView, setSelectedCatalogEntryView }: IJawazakTableProps) => {
	const classes = useStyles();
	const [checkedType, setCheckedType] = useState<types.services.jawazakType>('GCC');
	const [selectedTab, setSelectedTab] = useState<types.services.ISelectedJawazakTab | null>(null);

	const gccPackages: types.ecommerce.CatalogEntryView[] = useMemo(() => {
		return catalogEntryView.filter((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			const roamingType = extractAttributeValue({ attributes }, CustomAttribute.ROAMING_TYPE);
			return roamingType === 'JAWAZAK GCC';
		});
	}, [catalogEntryView]);

	const worldPackages: types.ecommerce.CatalogEntryView[] = useMemo(() => {
		return catalogEntryView.filter((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			const roamingType = extractAttributeValue({ attributes }, CustomAttribute.ROAMING_TYPE);
			return roamingType === 'JAWAZAK WORLD';
		});
	}, [catalogEntryView]);

	const setTab = (selectedTabNumber: number | null, type: types.services.jawazakType) => {
		setSelectedTab({
			selectedTabNumber,
			type,
		});
		if (selectedTabNumber !== null) {
			setSelectedCatalogEntryView(
				type === 'GCC' ? gccPackages[selectedTabNumber] : worldPackages[selectedTabNumber]
			);
		}
	};

	return (
		<div>
			<div className={classes.jawazakRadioButtons}>
				<CustomRadio
					checked={checkedType === 'GCC'}
					onChange={() => setCheckedType('GCC')}
					label={translate('jawazak.table.gcc')}
				/>
				<CustomRadio
					checked={checkedType === 'WORLD'}
					onChange={() => setCheckedType('WORLD')}
					label={translate('jawazak.table.world')}
				/>
			</div>
			<div>
				<SingleJawazakTable
					catalogEntryView={checkedType === 'GCC' ? gccPackages : worldPackages}
					setSelectedTab={(selectedTabNumber) => setTab(selectedTabNumber, checkedType)}
					selectedTab={selectedTab && selectedTab.type === checkedType ? selectedTab.selectedTabNumber : null}
				/>
			</div>
		</div>
	);
};

export default JawazakTable;
